/*global BMS*/
import {
    CLEAR_EVENT_OPEN_BETS,
    REMOVE_NO_MORE_BETS_EVENT,
    SELECT_EVENT,
    SET_EVENT_LAST_RESULTS,
    SET_EVENTS,
    SET_MATCHDAY_UPDATE,
    SET_NEXT_EVENTS_TIMESTAMP,
    SET_NO_MORE_BETS_EVENT,
    SET_RESULT,
    SET_RESULT_COUNTER,
    SET_SELECTED_MATCHDAY_EVENT_ID,
    SET_SELECTED_MATCHDAY_SUB_EVENT_INDEX,
    SET_EVENT_TAB_CLICK_STATUS
} from '../constants/actionTypes';
import {getSelectedEventIndex, groupMatchdayEvents} from '../helpers/eventHelpers';
import defaultStoreValues from '../constants/defaultStoreValues';
import {OPERATOR} from '../constants/operator';
import {updateSimplifiedLocalOpenBets} from '../ui-modules/simplified/helpers/betHelpers';
import {updateSportsBookLocalOpenBets} from "../ui-modules/sports-book/helpers/betHelpers";
import {MATCHDAY_MODULE_TYPE} from "../ui-modules/sports-book/modules/matchday/constants/identifiers";
import {
    MATCHDAY,
    VPP_MATCHDAY_ENGLISH_CHANNEL,
    VPP_MATCHDAY_GREEK_CHANNEL,
    VPP_MATCHDAY_MOROCCAN_CHANNEL,
    VPP_MATCHDAY_TURKISH_CHANNEL,
    VPP_MATCHDAY_BELGIUM_CHANNEL,
    VPP_MATCHDAY_LIGHT_ENGLISH_CHANNEL
} from "../constants/identifiers";

export default (state, action) => {
    let newOpenBetsList;
    let newOpenBetsHistory;
    let newEvents;
    let newNoMoreBetsEvents;
    let newGames;
    let result;
    let matchdayUpdates;
    switch (action.type) {
        case SET_EVENTS:
            // check if the events belong to the selected gameList
            newOpenBetsList = state.openBetsList.slice();
            let todayDate = Date.now() - state.serverTimeOffset;
            if (OPERATOR.clientType === 'Simplified') {
                newOpenBetsList = newOpenBetsList.filter((ob) => (!(ob.event.eventTimeDate < todayDate && !state.noMoreBetsEventList.find((ev) => ev.eventId === ob.event.eventId)) && !(ob.event.eventTimeDate < todayDate - 120000)));
            } else if (OPERATOR.clientType === 'SportsBook') {
                // newOpenBetsList = newOpenBetsList.filter((ob) => (!(ob.bets[0].event.eventTimeDate < todayDate.getTime() && !state.noMoreBetsEventList.find((ev) => ev.eventId === ob.bets[0].event.eventId)) && !(ob.bets[0].event.eventTimeDate < todayDate.getTime() - 120000)));
                newOpenBetsList = newOpenBetsList.map((ob) => {
                    if (!(ob.bets[0].event.eventTimeDate < todayDate && !state.noMoreBetsEventList.find((ev) => ev.eventId === ob.bets[0].event.eventId)) && !(ob.bets[0].event.eventTimeDate < todayDate - 120000)) {
                        return ob;
                    } else {
                        ob.bets.map((bet) => bet.hasExpired = true);
                        return ob;
                    }
                });
            }

            // when one event has ended, the outdated events must be removed if there are no current events then there wont exist
            // outdated ones either so they get concatenated
            let isMatchdayChannel = state.games[state.selectedGameIndex].type == MATCHDAY_MODULE_TYPE;
            if (action.eventHasEnded && state.events.length > 0 && (isMatchdayChannel ? action.endedEventChannel.includes(state.games[state.selectedGameIndex].channel) : state.games[state.selectedGameIndex].channel === action.endedEventChannel)) {
                let currentServerTime = Date.now() - state.serverTimeOffset;
                if (isMatchdayChannel) {
                    let matchdayEvents = [];
                    state.events.forEach(mdevents => {
                        if (mdevents && Array.isArray(mdevents)) {
                            mdevents.forEach(evt => matchdayEvents.push(evt));
                        }

                    });
                    newEvents = matchdayEvents;
                } else {
                    newEvents = state.events;
                }
                let isResultShowing = state.games.slice().filter((game) => (game.type === MATCHDAY_MODULE_TYPE ? action.endedEventChannel.includes(game.channel) : game.channel === action.endedEventChannel) && game.isResultShowing === true);
                if (isResultShowing === undefined || isResultShowing.length === 0) {
                    // OPERATOR.noMoreBetsinMs * 2 serves the purpose of not removing the events that are near its video time and receive a PRE message  [PROD_VSB-1304]
                    newEvents = newEvents.filter((evt) => (evt.eventTimeDate + OPERATOR.noMoreBetsinMs * 2) > currentServerTime);
                }
            } else {
                if (!action.nextEvents || action.nextEvents.length === 0 || action.nextEvents[0].channel !== state.games[state.selectedGameIndex].channel) {
                    return {
                        ...state,
                        openBetsList: newOpenBetsList
                    };
                }
                if (isMatchdayChannel) {
                    let matchdayEvents = [];
                    action.nextEvents.forEach(mdevents => mdevents.forEach(evt => matchdayEvents.push(evt)));
                    newEvents = matchdayEvents.slice();
                } else {
                    newEvents = action.nextEvents;
                }
            }

            let newSelectedEventIndex = state.selectedEventIndex;
            let newSelectedEventId;
            let newSelectedEventMultiBetList = state.selectedEventMultiBetList.slice();

            if (state.selectedEventIndex === 0) {
                newSelectedEventId = newEvents[0] !== undefined ? newEvents[0].eventId : undefined;
                if (newSelectedEventId !== state.selectedEventId) {
                    newSelectedEventMultiBetList = defaultStoreValues.selectedEventMultiBetList.slice();
                }
            } else {
                newSelectedEventIndex = getSelectedEventIndex(state.selectedEventId, newEvents);
                newSelectedEventId = newEvents[newSelectedEventIndex].eventId;
            }

            let channelEventBetsToKeep = state.channelEventBets;

            if (state.channelEventBets && newEvents && newEvents.length > 0 && newEvents[0].channel === state.games[state.selectedGameIndex].channel) {
                let channelId = newEvents[0].channel;
                let eventBets = state.channelEventBets[channelId];

                if (eventBets && eventBets.length > 0) {
                    let eventBetsToKeep = [];
                    let eventIds = Object.keys(eventBets);

                    for (let i = 0; i < eventIds.length; i++) {
                        let eventId = eventIds[i];

                        newEvents.forEach((event) => {
                            if (Number(event.eventId) === Number(eventId)) {
                                eventBetsToKeep[eventId] = state.channelEventBets[channelId][eventId];
                            }
                        });
                    }

                    channelEventBetsToKeep[channelId] = eventBetsToKeep;
                }
            }

            if (isMatchdayChannel) {
                newEvents = groupMatchdayEvents(newEvents);
                newSelectedEventIndex = Math.floor(newSelectedEventIndex / 8);
            }
            return {
                ...state,
                events: newEvents,
                selectedEventIndex: newSelectedEventIndex,
                selectedEventId: newSelectedEventId,
                selectedEventMultiBetList: newSelectedEventMultiBetList,
                openBetsList: newOpenBetsList,
                channelEventBets: channelEventBetsToKeep
            };

        case SELECT_EVENT:
            let newSelectedEventIdx = action.eventIndex;

            if (newSelectedEventIdx < 0 || newSelectedEventIdx >= state.events.length) {
                return state;
            } else {
                let newEventId;
                if (state.events[newSelectedEventIdx].eventType === MATCHDAY) {
                    newEventId = state.events[newSelectedEventIdx][0].eventId;
                } else {
                    newEventId = state.events[newSelectedEventIdx].eventId;
                }
                return {
                    ...state,
                    selectedEventIndex: newSelectedEventIdx,
                    selectedEventId: newEventId,
                    selectedEventMultiBetList: defaultStoreValues.selectedEventMultiBetList.slice(),
                    messageBar: defaultStoreValues.messageBar
                };
            }
        case SET_SELECTED_MATCHDAY_SUB_EVENT_INDEX:
            if (process.env.NODE_ENV !== 'development' && !state.isVideoMuted) {
                BMS.Operator.updateGameSound(false);
            }
            return {
                ...state,
                selectedMatchdaySubEventIndex: action.selectedMatchdaySubEventIndex,
                isVideoMuted:true
            };
        case SET_EVENT_TAB_CLICK_STATUS:
            return {
                ...state,
                isEventTabClicked: action.isEventTabClicked
            };
        case SET_SELECTED_MATCHDAY_EVENT_ID:
            return {
                ...state,
                matchday: {
                    selectedMatchdayEventId: action.selectedMatchdayEventId
                }
            };
        case SET_NEXT_EVENTS_TIMESTAMP:
            return {
                ...state,
                nextEventsTimeStamp: action.nextEventsTimeStamp
            };

        case SET_NO_MORE_BETS_EVENT:
            newNoMoreBetsEvents = state.noMoreBetsEventList.slice();
            // add event timedate to filter events on remove noMoreBetsList
            let stateEvents;
            if (state.events !== undefined && state.events.eventType === MATCHDAY_MODULE_TYPE) {
                let matchdayEvents = [];
                state.events.forEach(mdevents => mdevents.forEach(evt => matchdayEvents.push(evt)));
                stateEvents = matchdayEvents;
            } else {
                stateEvents = state.events;
            }
            let eventInList = stateEvents.find((event) => event !== undefined && event.channel === action.nmbEvent.gameChannel && event.eventId === action.nmbEvent.eventId);
            action.nmbEvent.eventTimeDate = eventInList !== undefined ? eventInList.eventTimeDate : undefined;

            if (!newNoMoreBetsEvents.find((evt) => action.nmbEvent.eventId === evt.eventId && action.nmbEvent.gameChannel === evt.gameChannel)) {
                newNoMoreBetsEvents.push(action.nmbEvent);
            }

            return {
                ...state,
                noMoreBetsEventList: newNoMoreBetsEvents
            };

        case SET_RESULT:
            result = action.params;
            let gameIndex = state.games.findIndex(e => e !== undefined && result.channel === e.channel);
            newGames = state.games.slice();
            if(newGames[gameIndex] !== undefined) {
                if (result.channel === VPP_MATCHDAY_TURKISH_CHANNEL || result.channel === VPP_MATCHDAY_ENGLISH_CHANNEL
                    || result.channel === VPP_MATCHDAY_GREEK_CHANNEL || result.channel === VPP_MATCHDAY_MOROCCAN_CHANNEL
                    || result.channel === VPP_MATCHDAY_BELGIUM_CHANNEL || result.channel === VPP_MATCHDAY_LIGHT_ENGLISH_CHANNEL) {
                    if (newGames[gameIndex].lastResult === undefined || (newGames[gameIndex].lastResult.length > 0 && newGames[gameIndex].lastResult[0].eventTime !== result.eventTime)) {
                        newGames[gameIndex].lastResult = [];
                    }
                    newGames[gameIndex].lastResult.push(result);
                    if (newGames[gameIndex].lastResult.length === 8) {
                        newGames[gameIndex].isResultCountDownStart = true;
                        newGames[gameIndex].isResultShowing = false;
                    }
                } else {
                    newGames[gameIndex].lastResult = result;
                    newGames[gameIndex].isResultCountDownStart = true;
                    newGames[gameIndex].isResultShowing = false;
                }
            }

            return {
                ...state,
                games: newGames
            };
        case SET_MATCHDAY_UPDATE:
            matchdayUpdates = action.params;
            newGames = state.games.slice();
            Object.keys(matchdayUpdates).forEach((mdData) => {
                Object.values(matchdayUpdates[mdData]).forEach((channelData) => {
                    if (channelData.channel !== undefined) {
                        let matchdayGameIndex = state.games.findIndex(e => e !== undefined && channelData.channel === e.channel);
                        if (matchdayGameIndex !== -1) {
                            if (mdData === 'leagueUpdate') {
                                newGames[matchdayGameIndex].leagueUpdate = channelData.data;
                            } else if (mdData === 'goalTimings') {
                                //historicGoalTimings is required to handle 1 minute games.
                                newGames[matchdayGameIndex].historicGoalTimings = newGames[matchdayGameIndex].goalTimings;
                                newGames[matchdayGameIndex].goalTimings = channelData.data;
                            }
                        }
                    }
                });
            });

            return {
                ...state,
                games: newGames,
                matchdayUpdated: true
            };

        case SET_RESULT_COUNTER:
            channel = action.channel;
            let index = state.games.findIndex(e => e !== undefined && channel === e.channel);
            newGames = state.games.slice();
            newGames[index].isResultCountDownStart = action.state;
            newGames[index].isResultShowing = action.isResultShowing;

            return {
                ...state,
                games: newGames
            };

        case REMOVE_NO_MORE_BETS_EVENT:
            let currentServerTime = Date.now() - state.serverTimeOffset;

            newNoMoreBetsEvents = state.noMoreBetsEventList.slice();
            let isResultShowing = state.games.slice().filter((game) => (game.type === MATCHDAY_MODULE_TYPE ? action.channel.includes(game.channel) : game.channel === action.channel) && game.isResultShowing === true);
            if (isResultShowing === undefined || isResultShowing.length === 0) {
                // remove nmbEvent and expire all that are older than 5 minutes (currently no video plays longer than that).
                newNoMoreBetsEvents = newNoMoreBetsEvents.filter((nmbEv) => (!(action.channel.includes(nmbEv.gameChannel) && (nmbEv.eventTimeDate === undefined && nmbEv.eventTimeDate < currentServerTime)) || (nmbEv.creationDateTime + 300000) > currentServerTime));
            }
            // remove bet history from passed events
            let newBetHistoryBets = state.betHistoryBets.filter(betHistoryBet => {
                let isBetFromANoMoreBetsEvent = newNoMoreBetsEvents.find(newNoMoreBetsEvent => newNoMoreBetsEvent.gameChannel.toString() === betHistoryBet.Bets[0].Channel.toString() && newNoMoreBetsEvent.eventId.toString() === betHistoryBet.Bets[0].EventId.toString()) !== undefined;
                return isBetFromANoMoreBetsEvent || betHistoryBet.Bets[0].EventTime >= currentServerTime;
            });

            return {
                ...state,
                noMoreBetsEventList: newNoMoreBetsEvents,
                betHistoryBets: newBetHistoryBets
            };
        case CLEAR_EVENT_OPEN_BETS:
            if (OPERATOR.clientType === 'Simplified') {
                newOpenBetsList = state.openBetsList.slice().filter((openBet) => openBet.game.channel !== action.gameChannel || (openBet.game.channel === action.gameChannel && openBet.event.eventId !== action.eventId));
                newOpenBetsHistory = state.openBetsHistory.slice().filter((openBetHistory) => openBetHistory.game.channel !== action.gameChannel || (openBetHistory.game.channel === action.gameChannel && openBetHistory.event.eventId !== action.eventId));
                updateSimplifiedLocalOpenBets(state.playerUID, newOpenBetsList, newOpenBetsHistory);
            } else if (OPERATOR.clientType === 'SportsBook') {
                newOpenBetsList = state.openBetsList.slice().map((openBet) => {
                    if (openBet.bets[0].game.channel !== action.gameChannel || (openBet.bets[0].game.channel === action.gameChannel && openBet.bets[0].event.eventId !== action.eventId)) {
                        return openBet;
                    } else {
                        openBet.bets.map((bet) => bet.hasExpired = true);
                        return openBet;
                    }
                });

                updateSportsBookLocalOpenBets(newOpenBetsList, state.playerUID);
            }

            return {
                ...state,
                openBetsList: newOpenBetsList,
                openBetsHistory: newOpenBetsHistory
            };
        case SET_EVENT_LAST_RESULTS:
            let channel = action.result.eventDetails[0].channel;
            let newGameIndex = state.games.findIndex(e => e !== undefined && e.channel === channel);
            newGames = state.games.slice();
            newGames[newGameIndex].lastResults = action.result.lastResults;

            return {
                ...state,
                games: newGames
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/eventsReducer.js